/**
 * Signing in, on a device that has never played.
 *
 * THE CASE THE PANEL COULD NOT SERVE. `AccountPanel` sits at the bottom of the
 * home screen and discloses itself, which is right for a guest who has been
 * playing and might want to keep it. It is wrong for somebody who already has
 * an account and has just opened the game on a new phone: they land on
 * `FirstRunScreen`, which offers a tutorial they do not need, and the only way
 * onward is to skip it, scroll past a launcher, and read a button that says
 * "Save my progress" as though it were for people with nothing to save.
 *
 * Nothing about the mechanism changed. Signing in with an address that already
 * has an account has always restored it rather than making a second one --
 * `deviceOf` returns null for a browser with no token and the gateway treats
 * that as a restore. What was missing was a door.
 */

import { AccountPanel } from '../components/AccountPanel';
import { navigate } from '../lib/router';

export function SignInScreen(): React.JSX.Element {
  return (
    <main className="gg-screen gg-scroll">
      <header className="gg-hero">
        <h1 className="gg-title">Sign in</h1>
        <p className="gg-subtitle">
          Use the address your account is on and everything comes back: what you have found, your
          scores, and who you have beaten.
        </p>
      </header>

      <AccountPanel defaultOpen restoring />

      <section className="gg-section gg-section-quiet">
        <button type="button" className="gg-btn" onClick={() => navigate({ name: 'home' })}>
          Back
        </button>
      </section>
    </main>
  );
}
